import {
  BUDGET_VIEW_COLUMNS,
  TASK_BUDGET_VIEW_FILTER_FIELD_CONFIG
} from "./TaskBudget/taskBudgetViewColumnsData.js";
import { ICON_COL_DEF_WIDTH, SWIVU_GROUP_CONTEXT_MENU_SELECTOR } from "./OtherKeys.jsx";
import {
  cellMenuItemCollapseAllRows,
  cellMenuItemCollapseRow,
  cellMenuItemRemoveRow,
  cellMenuItemToggleArchiveRow
} from "../utils/gridCellMenuUtils.jsx";
import { EntityMainNameDefault, getCustomGroupRenderer, getOriginalRecord, lineThroughRenderer } from "../utils/utils.jsx";
// import { WIDGET_KEYS } from "./WidgetKeys.jsx";
import { getBudgetIcon } from "../../bryntum-lib/columns/BudgetAccountColumn.jsx";
import { WIDGET_KEYS } from "@/other/constants/WidgetKeys.jsx";

const TASK_BUDGET_GRID_CONFIG = {
  cls: "task-budget-grid",
  columns: [
    {
      id: "task-budget-column",
      editor: false,
      htmlEncode: false,
      width: 30,
      minWidth: ICON_COL_DEF_WIDTH,
      text: "Budget",
      cellCls: "cursor-pointer",
      cls: "swivu-icon-column",
      filterable: false,
      sortable: false,
      groupable: false,
      region: "locked",
      headerRenderer() {
        return `<div>
          ${getBudgetIcon()}
        </div>`;
      },
      renderer({ record }) {
        if (!record.isGroupHeader) {
          return `<div>
            ${getBudgetIcon(record, (record.budgetTasks ?? []).length > 0)}
          </div>`;
        }
      },
      headerMenuItems: {
        addNewEntity: {
          _menuId: "budget",
          icon: "fa-plus",
          text: "New Budget",
          weight: 10
        }
      },
    },
    ...BUDGET_VIEW_COLUMNS,
    { id: "task-budget-aging", text: "Age", field: "aging", flex: 1, type: "agingColumn", editor: false },
    {
      id: "budget-tasks",
      field: "budgetTasksValues",
      type: WIDGET_KEYS.columnTaskBudgetText,
      text: "Linked Tasks",
      htmlEncode: false,
      region: "normal",
      // Bug: Relations are not working properly, the relation field which is supposed to return a array of record is returning undefined which is causing a crash
      // For now, we are disabling the element editor in the grid to prevent crashes and a default value of empty array to prevent crashes in renderer
      // type: WIDGET_KEYS.columnTaskBudgetText,
      editor: false,
      cellCls: "swivu-recipients-cell flex gap-[0.5em]",
      sum: false,
      groupRenderer(e) {
        return getCustomGroupRenderer(e);
      },
      renderer({ record }) {
        if (!record.isGroupHeader) {
          const originalRecord = getOriginalRecord(record);
          const budgetTasks = originalRecord.budgetTasks;
          const dataset = (v) => ({
            id: v.id,
            type: v.type
          });
          return budgetTasks && budgetTasks.length
            ? budgetTasks.map((v) => EntityMainNameDefault({
              ...lineThroughRenderer(v.name || "N/A", false),
              dataset: dataset(v)
            }))
            : EntityMainNameDefault();
        }
      },
    }
  ],
  stateId: true,
  filterFeature: {
    pickerConfig: {
      fields: TASK_BUDGET_VIEW_FILTER_FIELD_CONFIG
    },
    closeEmptyPopup: true
  },
  columnReorderFeature: false,
  animateRemovingRows: false,
  preserveScrollOnDatasetChange: true,
  statefulEvents: [
    "subGridCollapse",
    "subGridExpand",
    "horizontalScroll",
    "stateChange",
    "scroll",
    "swivuAllTaskBudgetStoreStoreFilter",
    "swivuAllTaskBudgetStoreStoreSort",
    "swivuAllTaskBudgetStoreStoreGroup"
  ],
  rowReorderFeature: false,
  cellMenuFeature: {
    clickTriggerSelector: SWIVU_GROUP_CONTEXT_MENU_SELECTOR,
    items: {
      cut: false,
      copy: false,
      paste: false,
      collapseRow: cellMenuItemCollapseRow(),
      collapseAllRows: cellMenuItemCollapseAllRows(),
      removeRow: cellMenuItemRemoveRow(),
      archive: cellMenuItemToggleArchiveRow(),
    }
  },
  regionResizeFeature: true,
  summaryFeature: true,
  subGridConfigs: {
    locked: {
      weight: 20,
      width: 225
    },
    normal: {
      weight: 30
    }
  },
  headerMenuFeature: {
    items: {
      lockedRegion: false,
      normalRegion: false
    }
  },
  sortFeature: true,
  selectionMode: {
    row: true,
    showCheckAll : true,
    checkbox: {
      id: "budget-checkbox",
      enableHeaderContextMenu: false
    },
    checkboxOnly: true
  }
};

export { TASK_BUDGET_GRID_CONFIG };
